/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'
import { z } from 'zod'

const legacySearch = z.object({
  page: z.number().optional(),
  sortBy: z.string().optional(),
  search: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/(admin-layout)/admin/paymentrequests/')({
  validateSearch: legacySearch,
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/admin/payments',
      search: {
        tab: 'pending',
        page: search.page,
        sortBy: search.sortBy,
        search: search.search,
      } as never,
      statusCode: StatusCodes.MOVED_PERMANENTLY,
    })
  },
})
